import { Table, Typography, Card, Row, Col, Tag } from "antd";
import dayjs from "dayjs";
import { useGetFeedbacksByUser } from "./ServerSideStates";
import { useState, useEffect } from "react";

const { Text } = Typography;

const ListItems = () => {
  const [isMobile, setIsMobile] = useState(false);
  
  useEffect(() => {
    const checkIfMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };
    
    checkIfMobile();
    window.addEventListener('resize', checkIfMobile);
    
    return () => window.removeEventListener('resize', checkIfMobile);
  }, []);

  const columns = [
    {
      title: "Kategori",
      dataIndex: ["reportCategory", "name"],
      key: "category",
      width: 150,
      render: (value: string) => {
        return (
          <Tag color="blue" className="text-xs">
            {value || "Kategori Yok"}
          </Tag>
        );
      }
    },
    {
      title: "Oluşturma Tarihi",
      dataIndex: "insertDate",
      key: "insertDate",
      width: 230,
      sorter: (a: any, b: any) => dayjs(a.insertDate).unix() - dayjs(b.insertDate).unix(),
      render: (text: string) => (
        <Text className="text-sm">
          {dayjs(text).format("DD.MM.YYYY")}
        </Text>
      ),
    },
    {
      title: "Açıklama",
      dataIndex: "description",
      key: "description",
      ellipsis: true,
      render: (text: string) => (
        <Text className="text-sm" title={text}>
          {text}
        </Text>
      ),
    },
  ];

  const feedbacks = useGetFeedbacksByUser();

  // Mobile Card View
  const MobileCardView = ({ data }: { data: any[] }) => {
    return (
      <div className="space-y-4">
        {data.map((item, index) => (
          <Card 
            key={item.id || index} 
            className="shadow-sm"
            size="small"
          >
            <Row gutter={[0, 8]}>
              <Col span={24}>
                <div className="flex justify-between items-center">
                  <Text strong className="text-gray-600 text-xs">Kategori</Text>
                  <Tag color="blue" className="text-xs">
                    {item.reportCategory?.name || "Kategori Yok"}
                  </Tag>
                </div>
              </Col>
              
              <Col span={24}>
                <div className="flex justify-between items-center">
                  <Text strong className="text-gray-600 text-xs">Tarih</Text>
                  <Text className="text-sm">
                    {dayjs(item.insertDate).format("DD.MM.YYYY")}
                  </Text>
                </div>
              </Col>
              
              <Col span={24}>
                <div className="space-y-2">
                  <Text strong className="text-gray-600 text-xs">Açıklama</Text>
                  <Text className="text-sm block">
                    {item.description}
                  </Text>
                </div>
              </Col>
            </Row>
          </Card>
        ))}
      </div>
    );
  };

  const data = feedbacks?.data?.data || [];

  if (feedbacks.isLoading || feedbacks.isFetching) {
    return (
      <div className="flex justify-center items-center py-12">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500"></div>
      </div>
    );
  }

  return (
    <div className="w-full">
      {isMobile ? (
        <>
          <MobileCardView data={data} />
          {data.length > 20 && (
            <div className="flex justify-center mt-6">
              <Text className="text-sm text-gray-500">
                Toplam {data.length} kayıt
              </Text>
            </div>
          )}
        </>
      ) : (
        <div className="overflow-x-auto">
          <Table
            columns={columns}
            dataSource={data}
            loading={feedbacks.isLoading || feedbacks.isFetching}
            rowKey="id"
            scroll={{ x: 600 }}
            className="min-w-full"
            pagination={{
              className: "flex justify-center md:justify-end",
              total: data.length,
              pageSize: 20,
              showLessItems: true,
              size: "small",
              showSizeChanger: true,
              locale: { items_per_page: "" },
              showTotal: (total) => `Toplam ${total} kayıt`,
              responsive: true,
            }}
          />
        </div>
      )}
      
      {data.length === 0 && !feedbacks.isLoading && (
        <div className="text-center py-12">
          <Text className="text-gray-500">Henüz soru veya öneri bulunmuyor.</Text>
        </div>
      )}
    </div>
  );
};

export default ListItems;